import { baseURL } from './config'
import { QueryParameter } from './types'

const path = require('path')

export function usePath(uriFunctor = () => baseURL, ...relativePathFragments: string[]) {
  const requestURL = new URL(uriFunctor().href)
  requestURL.pathname = path.join(...[requestURL.pathname, ...relativePathFragments])
  return requestURL
}

export function usePathFromBaseURI(...relativePathFragments: string[]) {
  return usePath(() => baseURL, ...relativePathFragments)
}

export function useQuery(uriFunctor = () => baseURL, ...queryParams: QueryParameter[]) {
  const requestURL = new URL(uriFunctor().href)
  queryParams.forEach(item => {
    requestURL.searchParams.append(item.name, item.value != null ? item.value.toString() : 'null')
  })
  return requestURL
}